module.exports = __webpack_public_path__ + "static/media/block-2-item-6.3f6374e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-2-item-6.jpg
// module id = 1256
// module chunks = 270